import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "cain-link-3" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M8.12519 5.10305L8.9306 4.29764C10.9386 2.28962 14.1943 2.28962 16.2023 4.29764C18.2103 6.30566 18.2103 9.5613 16.2023 11.5693L15.3951 12.3765M4.60734 8.6209L3.79764 9.4306C1.78962 11.4386 1.78962 14.6943 3.79764 16.7023C5.80566 18.7103 9.0613 18.7103 11.0693 16.7023L11.8731 15.8985M7.91663 12.5833L12.0833 8.41663",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      })
    ], -1)
  ])))
}
export default { render: render }